<template>
    <div class="c-modal" :class="[visible ? 'c-modal--open' : '']">
        <div class="modal__inner">
            <div class="modal-close">
                <button class="c-button-close" @click="close" area-label="close"></button>
            </div>
            <h3 class="modal__heading">{{ title }}</h3>
            <div class="modal__content">
                <slot></slot>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            title: { type: String },
            visible: { type: Boolean }
        },
        methods: {
            close: function () {
                this.$emit("close");
            }
        }
    }
</script>